export default {"src":"/_next/static/media/iot.e9bea4b6.svg","height":62,"width":62,"blurWidth":0,"blurHeight":0};